module.exports = __webpack_public_path__ + "img/icon4.f01d4f5f.png";